/* lazy-owl.js — simple, reliable lazy init for homepage featured collections */
(function () {
  function onReady(fn){document.readyState!=='loading'?fn():document.addEventListener('DOMContentLoaded',fn);}

  onReady(function () {
    // Only run on homepage
    if (!document.body.classList.contains('template-index')) return;

    // Need jQuery + Owl
    var $ = window.jQuery;
    if (!$ || !$.fn || !$.fn.owlCarousel) return;

    var SELECTOR = 'ul.product-grid.owl-carousel';

    function init(el){
      var $el = $(el);
      if ($el.hasClass('owl-loaded')) return;
      var opts = $el.data('owl-opts') || {};   // set in the section script
      try { $el.owlCarousel(opts); } catch(e){}
    }

    function nearViewport(el, margin){
      var r = el.getBoundingClientRect();
      return r.top < (window.innerHeight + (margin||120)) && r.bottom > -50;
    }

    // Init anything already near the top
    document.querySelectorAll(SELECTOR).forEach(function(el){
      if (nearViewport(el, 80)) init(el);
    });

    // Observe the rest and init as they approach
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function(entries, obs){
        entries.forEach(function(e){
          if (!e.isIntersecting) return;
          init(e.target);
          obs.unobserve(e.target);
        });
      }, { rootMargin: '400px 0px' });

      document.querySelectorAll(SELECTOR).forEach(function(el){ io.observe(el); });

      // If sections are re-rendered, observe new ones
      new MutationObserver(function(){
        document.querySelectorAll(SELECTOR).forEach(function(el){ io.observe(el); });
      }).observe(document.body, { childList:true, subtree:true });
    } else {
      // Fallback: on scroll
      var t;
      window.addEventListener('scroll', function(){
        clearTimeout(t);
        t = setTimeout(function(){
          document.querySelectorAll(SELECTOR).forEach(function(el){
            if (!$(el).hasClass('owl-loaded') && nearViewport(el, 300)) init(el);
          });
        }, 120);
      }, { passive:true });
    }
  });
})();
